// noSpecialCharsDirective.js
export const emailSpecialCharsDirective = {
    mounted(el, binding) {
        const inputHandler = (e) => {
            let moduleType = e.target.dataset.moduleType;
            let sanitizedValue;
            let value = e.target.value;
            sanitizedValue = value.replace(/[^\u4e00-\u9fa5áéíóúüñÁÉÍÓÚÑÀ-ÿа-яА-Я-\w.@/ ]/g,'');
            if (sanitizedValue !== value) {
                e.target.value = sanitizedValue;
                // 手动触发 input 事件以更新 v-model 绑定的值
                e.target.dispatchEvent(new Event('input'));
            }
        };
        el.addEventListener('input', inputHandler);
        // 保存处理程序以便在卸载时移除
        el.__inputHandler__ = inputHandler;
    },
    unmounted(el) {
        // 移除事件监听器
        el.removeEventListener('input', el.__inputHandler__);
        delete el.__inputHandler__;
    }
};
